module.exports = __webpack_public_path__ + "static/img/weixiao.1a9f502d.svg";